<template>
    <ion-nav :root="TrapSelectionModal"></ion-nav>
</template>

<script setup lang="ts">
import {IonNav} from "@ionic/vue";
import TrapSelectionModal from "@/components/modals/TrapSelectionModal.vue";
import {PropType, provide} from "vue";
import {IInspection} from "@/types/inspection";
const props = defineProps({
    inspection: {
        type: Object as PropType<IInspection>,
        required: true,
    }
});
provide('inspection', props.inspection);
</script>
